import * as actionType from "../constants";
import * as commonData from "../Common";

export const getBoardDetailsAction = (input, user_uuid) => {
  const apiUrl = commonData.commonData().apiUrl;
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      const response = await fetch(`${apiUrl}board-details`, {
        method: "post",
        body: JSON.stringify({
          app_token: commonData.getCommonData().app_token,
          attribute_set_key: input,
          user_uuid: commonData.getCommonData().user_uuid,
        }),
      });

      const rdata = await response.json();
      if (rdata.code === 200) {
        dispatch({
          type: actionType.GET_BOARD_FILTER_ACTION,
          data: rdata.data[0],
        });
        return resolve(rdata);
      } else {
        dispatch({ type: actionType.GET_BOARD_FILTER_ACTION, data: {} });
        return reject(rdata);
      }
    });
  };
};
